module.exports = __webpack_public_path__ + "img/new.12134f06.svg";